import { MenuItem } from '@mui/material';
import { CustomSelect, HorizontalForm } from '../../../../common/components';

const HistoricalProgressFilters = ({ projects, selectedProject, onProjectChange }) => {
  return (
    <HorizontalForm>
      <CustomSelect
        label="Proyecto"
        name="uuid_project"
        value={selectedProject || ''}
        onChange={onProjectChange}
        size="medium"
        sx={{ maxWidth: '520px' }}
      >
        <MenuItem value="">Seleccionar proyecto</MenuItem>
        {(projects || []).map((project) => (
          <MenuItem key={project.uuid} value={project.uuid}>
            {project.name}
          </MenuItem>
        ))}
      </CustomSelect>
    </HorizontalForm>
  );
};

export default HistoricalProgressFilters;
